import { render, staticRenderFns } from "./SreportForms.vue?vue&type=template&id=8c5398a0&scoped=true&"
import script from "./SreportForms.vue?vue&type=script&lang=ts&"
export * from "./SreportForms.vue?vue&type=script&lang=ts&"
import style0 from "./SreportForms.vue?vue&type=style&index=0&id=8c5398a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5398a0",
  null
  
)

export default component.exports